import React from "react";
import styled from "styled-components";
import variables from "../../../constants/assets/variables";

const DateTimePicker = ({
  placeholder = "Select time",
  id = "dateTimePicker",
  handleChange = () => {},
  value = "",
  disabled = false,
  disableBefore = "",
  disableAfter = "",
}) => {
  return (
    <DateTimePickerContainer>
      <input
        type="datetime-local"
        id={id}
        onChange={handleChange}
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        min={disableBefore}
        max={disableAfter}
      ></input>
    </DateTimePickerContainer>
  );
};

const DateTimePickerContainer = styled.div`
  height: 3rem;
  margin-bottom: 30px;
  position: relative;
  input {
    height: 100%;
    border: 1px solid ${variables.grey300};
    background-color: ${variables.grey100};
    border-radius: 8px;
    padding: 14px 18px;
    font-size: 1rem !important;
    width: ${({ width }) => (width ? width : "60%")};
    &::before {
      content: attr(placeholder);
      width: fit-content;
      padding: 4px;
      position: absolute;
      top: -12px;
      left: 8px;
      background-color: ${variables.white};
      font-size: 0.75rem;
      color: ${variables.grey700};
    }
  }
`;

export default DateTimePicker;
